import { Tooltip } from '@speeki/global-ui-components';

import { HeaderLogos } from '@components/molecules/HeaderLogos/HeaderLogos';
import { DesktopMenu } from '@components/organisms/DesktopMenu/DesktopMenu';
import { Divider } from '@components/organisms/DesktopMenu/DesktopMenu.styled';
import { MobileMenu } from '@components/organisms/MobileMenu/MobileMenu';

import { useResponsive } from '@utils/hooks/useResponsive';

import {
    CurrentSubsidiary,
    HeaderWrapper,
    SubsidiaryAndLogoWrapper,
} from './Header.styled';

export interface UserHeaderProps {
    className?: string;
    currentSubsidiary?: string;
}
export const UserHeader = ({
    className,
    currentSubsidiary,
}: UserHeaderProps) => {
    const isLg = useResponsive('lg');

    const isLongSubsidiaryName = (currentSubsidiary?.length ?? 0) > 40;
    const shortenSubsidiaryName = `${currentSubsidiary?.slice(0, 40)}... `;

    if (!isLg)
        return (
            <HeaderWrapper className={className}>
                <SubsidiaryAndLogoWrapper>
                    <HeaderLogos />
                    {currentSubsidiary && <Divider />}
                    {isLongSubsidiaryName ? (
                        <Tooltip
                            placement={'bottom'}
                            removePortal
                            strategy={'fixed'}
                            testId="6fnTJVs"
                            text={currentSubsidiary}
                            width={320}
                        >
                            <div>
                                <CurrentSubsidiary>
                                    {shortenSubsidiaryName}
                                </CurrentSubsidiary>
                            </div>
                        </Tooltip>
                    ) : (
                        <CurrentSubsidiary>
                            {currentSubsidiary}
                        </CurrentSubsidiary>
                    )}
                </SubsidiaryAndLogoWrapper>
                <DesktopMenu />
            </HeaderWrapper>
        );

    return (
        <MobileMenu
            className={className}
            currentSubsidiary={currentSubsidiary}
        />
    );
};
